import {
  Directive,
  ElementRef,
  Input,
  OnInit
} from '@angular/core';
import { Router } from '@angular/router';

@Directive({
  selector: '[fiMaskSearched]',
  standalone: false
})
export class MaskSearchedDirective implements OnInit {

  constructor(
    private el: ElementRef,
    private router: Router
  ) {
  }

  @Input('fiMaskSearched') fieldValue: string;
  @Input() categoryName: string;

  ngOnInit(): void {
    this.maskSearched();
  }

  maskSearched(): void {
    const routUrl = this.router.url;
    const categoryName = this.router.parseUrl(routUrl).queryParamMap.get('n');
    let searchedValue = this.router.parseUrl(routUrl).queryParamMap.get('q');
    let commissionSearch = [];
    let contactSearch = [];
    let responsibleSearch = [];

    if (searchedValue && ((this.categoryName === 'All' || !categoryName || categoryName === this.categoryName)) || categoryName === 'Filters') {
      if (categoryName === 'Filters') {
        if (this.router.parseUrl(routUrl).queryParamMap.get('commission')) {
          searchedValue = this.router.parseUrl(routUrl).queryParamMap.get('commission');
          if (searchedValue.includes(',')) {
            commissionSearch = commissionSearch.concat(searchedValue.split(','));
          } else {
            commissionSearch = commissionSearch.concat([searchedValue])
          }
        }

        // if(this.el?.nativeElement?.classList?.includes('address-text')){
        // this.fieldValue = this.el.nativeElement.innerHTML;
        // }

        if (this.router.parseUrl(routUrl).queryParamMap.get('contact')) {
          searchedValue = this.router.parseUrl(routUrl).queryParamMap.get('contact');
          if (searchedValue.includes(',')) {
            contactSearch = contactSearch.concat(searchedValue.split(','));
          } else {
            contactSearch = contactSearch.concat([searchedValue])
          }
        }
        if (this.router.parseUrl(routUrl).queryParamMap.get('responsible')) {
          searchedValue = this.router.parseUrl(routUrl).queryParamMap.get('responsible');
          if (searchedValue.includes(',')) {
            responsibleSearch = responsibleSearch.concat(searchedValue.split(','));
          } else {
            responsibleSearch = responsibleSearch.concat([searchedValue])
          }
        }
      }

      if (responsibleSearch?.length || commissionSearch?.length || contactSearch?.length) {
        // for (let data of searchedArray) {
        // if (data) {
        const replacedElements = (data) => '<span style ="color: var(--shared-color-text-brand-primary-default);">' + this.capitalizeFirstLetter(data) + '</span>';
        const replacedElementsWithoutCapitalize = (data) => '<span style ="color: var(--shared-color-text-brand-primary-default);">' + data + '</span>';
        // const pattern = new RegExp(data, 'gi');
        if (this.el.nativeElement.innerHTML) {
          this.el.nativeElement.innerHTML += ', '
        }
        const comissionText = this.fieldValue.includes('"comission"') ? this.fieldValue.split('<span class="comission">')[1] : '';
        let comissionEnd = comissionText ? comissionText.split('</span>')[0] : '';
        if(comissionEnd){
          this.fieldValue = this.fieldValue.replace(`<span class="comission">${comissionEnd}</span>`, '');
        }

        if (this.isContact) {
          this.el.nativeElement.innerHTML = this.replaceText(this.fieldValue, contactSearch, replacedElements);
        }
        if (this.isCommission) {
          this.el.nativeElement.innerHTML = this.replaceText(this.fieldValue, commissionSearch, replacedElements);
          if(comissionEnd){
            comissionEnd = this.replaceText(comissionEnd, commissionSearch, replacedElementsWithoutCapitalize)
            this.el.nativeElement.innerHTML = `<span class="comission">${comissionEnd}</span>` + this.el.nativeElement.innerHTML;
          }
        }
        if (this.isResponsible) {
          this.el.nativeElement.innerHTML = this.replaceText(this.fieldValue, responsibleSearch, replacedElements);
        }
      } else if (searchedValue) {
        const replacedElements = '<span style ="color: var(--shared-color-text-brand-primary-default);">' + this.capitalizeFirstLetter(searchedValue) + '</span>';
        const pattern = new RegExp(searchedValue, 'gi');
        this.el.nativeElement.innerHTML = this.fieldValue.replace(pattern, replacedElements);
      }

    }
  }

  get isContact(): boolean {
    return this.el.nativeElement.parentElement.className.includes('contact-name');
  }

  get isResponsible(): boolean {
    return this.el?.nativeElement?.parentElement?.parentElement?.className?.includes('responsible-column');
  }

  get isCommission(): Element | null {
    return this.el.nativeElement.closest('.address-text');
  }

  replaceText(value, strToReplace, replacementStr): string {
    const escapedStrings = strToReplace.map(str => this.escapeStr(str));
    const pattern = new RegExp(escapedStrings.join('|'), 'gi');
    return value.replace(pattern, (match) => replacementStr(match));
  }

  escapeStr(str): string {
    return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }

  capitalizeFirstLetter(searchedValue): string {
    if (!searchedValue) {
      return ''
    }

    let defaultIndex = 0;
    let capitalized = '';
    const findedIndex = this.fieldValue.toLowerCase().indexOf(searchedValue.toLowerCase());

    for (let i = findedIndex; i < this.fieldValue.length; i++) {
      if (this.fieldValue.charAt(i).toUpperCase() === this.fieldValue.charAt(i)) {
        capitalized += searchedValue.charAt(defaultIndex).toUpperCase();
      } else {
        capitalized += searchedValue.charAt(defaultIndex).toLowerCase();
      }
      defaultIndex++;
    }
    return capitalized;
  }

}
